// extracted by mini-css-extract-plugin
module.exports = {"searchPageHero":"SearchPageHero_searchPageHero__va5sB","belowText":"SearchPageHero_belowText__FZq_S"};